import { darken } from '@theme-ui/color'
import { Theme } from 'theme-ui'

const links: Theme['links'] = {
  focus: {
    textDecoration: 'none',
    color: 'secondary',
    border: '1px solid',
    borderColor: 'secondary',
    p: 1,
  },
  visited: {
    textDecoration: 'underline',
    color: 'muted',
  },
  hover: {
    textDecoration: 'underline',
    color: 'primary',
    cursor: 'pointer',
  },
  breadcrumb: {
    color: 'primary',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: darken('primary', 0.15),
    },
    '&:active': {
      color: darken('primary', 0.18),
      fontWeight: '550',
      textDecoration: 'underline',
    },
  },
}

export default links
